const th = {
  kicker: "สำหรับธุรกิจและเทศบาล",
  title: "ปักหมุดสถานที่ของคุณบนแผนที่โทรลล์",
  lead: "ครอบครัว นักเดินป่า และนักท่องเที่ยวต่างตามล่าโทรลล์ไปตามฟยอร์ด สนับสนุนโทรลล์ของคุณเอง เลือกได้ว่าจะให้ยืนตรงไหน แล้วปล่อยให้การล่าพาผู้มาเยือนตรงมาถึงหน้าประตูคุณ — ทั้งโรงแรม คาเฟ่ ซาวน่า สวนสนุก หรือทั้งเทศบาลของคุณ",
  launchBadge: "ข้อเสนอเปิดตัว · ลด 50% สำหรับผู้สนับสนุน 50 รายแรก",
  ctaPackages: "ดูแพ็กเกจ",
  ctaContact: "คุยกับเรา",
  mockPin: "ธุรกิจของคุณอยู่ตรงนี้",
  mockVipps: "สั่งล่วงหน้าด้วย Vipps",
  mockNear: "มีโทรลล์อยู่ใกล้ · 2 นาที",
  whyKicker: "ทำไมต้องเป็นผู้สนับสนุน",
  whyTitle: "การล่าสมบัติที่เปลี่ยนผู้ผ่านทางให้เป็นลูกค้า",
  why: [
    { h: "ผู้มาเยือนมาหาคุณเอง", p: "โทรลล์ทุกตัวคือจุดหมายปลายทาง ผู้เล่นเดิน เล่นสกี และปั่นจักรยานเพื่อตามหามัน — นั่นหมายถึงผู้คนที่มาถึงหน้าประตูคุณ พร้อมแวะพัก กิน นอน และใช้จ่าย" },
    { h: "ปักหมุดบนแผนที่", p: "สถานที่ของคุณจะถูกปักหมุดบนแผนที่โทรลล์พร้อมโทรลล์ของคุณเอง นักสำรวจจะได้ค้นพบสถานที่น่าสนใจที่พวกเขาไม่มีทางหาเจอเอง" },
    { h: "สั่งล่วงหน้าผ่าน Vipps", p: "แขกสามารถสั่งล่วงหน้ากับคุณในแอปและจ่ายด้วย Vipps — กาแฟสักแก้ว วาฟเฟิลสักชิ้น รอบซาวน่า หรือตั๋ว — พร้อมรับเมื่อมาถึง" },
    { h: "ตลอดทั้งปี ทุกฤดูกาล", p: "เล่นสกีใต้แสงออโรรา กองไฟใต้พระอาทิตย์เที่ยงคืน เรนเดียร์ช่วงอีสเตอร์ และเดินป่าเก็บเห็ดในฤดูใบไม้ร่วง การล่าดึงดูดผู้มาเยือนได้ทั้งสี่ฤดู" },
    { h: "สื่อสารกับคนทั้งโลก", p: "เกมนี้มีทั้งภาษานอร์เวย์ ซามีเหนือ อังกฤษ จีน รัสเซีย และไทย สถานที่ของคุณจึงเข้าถึงได้ทั้งครอบครัวท้องถิ่นและนักท่องเที่ยวต่างชาติ" },
    { h: "โลโก้ของคุณบนเว็บไซต์เรา", p: "ผู้สนับสนุนจะแสดงพร้อมโลโก้และลิงก์บนเว็บไซต์ของเรา ใต้ปุ่ม App Store และ Google Play ที่ผู้เล่นทุกคนมองเห็น" },
  ],
  forKicker: "เหมาะสำหรับ",
  forTitle: "ทุกสถานที่ที่ควรค่าแก่การแวะ",
  forList: ["เทศบาลและภูมิภาค", "การท่องเที่ยวท้องถิ่น", "โรงแรมและกระท่อม", "ร้านอาหารและคาเฟ่", "ร้านเบเกอรี่", "ซาวน่าและสปา", "สวนสนุกและสวนกิจกรรม", "เส้นทางเดินและลานสกี", "บริษัทนำเที่ยว", "ชมรมและสมาคม", "ร้านค้าและร้านค้าฟาร์ม", "ลานกางเต็นท์"],
  pkgKicker: "แพ็กเกจผู้สนับสนุน",
  pkgTitle: "เลือกจำนวนโทรลล์ที่คุณต้องการ",
  pkgLead: "โทรลล์ที่วางตรงจุดที่คุณต้องการนานหนึ่งปี ต่ออายุได้ทุกปี ยิ่งมีโทรลล์มาก ราคาต่อตัวยิ่งถูกลง",
  launchNote: "ราคาเปิดตัวสำหรับผู้สนับสนุน 50 รายแรก — ลด 50% จากราคาปกติ",
  perYear: "ต่อปี · ไม่รวม VAT",
  regular: "ราคาปกติ",
  perTroll: "ตัวละ {price} kr",
  trolls: "โทรลล์ {n} ตัว",
  troll: "โทรลล์ 1 ตัว",
  popular: "ยอดนิยม",
  choose: "เลือก {name}",
  packages: {
    local: { name: "ท้องถิ่น", for: "คาเฟ่ ร้านเบเกอรี่ ซาวน่า และร้านค้าเล็ก ๆ", perks: ["โทรลล์ 1 ตัวที่หน้าร้าน", "ปักหมุดสถานที่ของคุณในแอป", "สั่งล่วงหน้าด้วย Vipps"] },
    business: { name: "ธุรกิจ", for: "ร้านอาหาร โรงแรม และผู้ให้บริการกิจกรรม", perks: ["โทรลล์ 5 ตัวในสถานที่ของคุณ", "เลือกประเภทโทรลล์ได้เอง", "สั่งล่วงหน้าด้วย Vipps", "โลโก้และลิงก์บนเว็บไซต์เรา"] },
    destination: { name: "จุดหมายปลายทาง", for: "สวนสนุก รีสอร์ต และเครือข่ายเส้นทางเดิน", perks: ["โทรลล์ 10 ตัวทั่วพื้นที่ของคุณ", "เลือกประเภทโทรลล์ได้เอง", "สั่งล่วงหน้าด้วย Vipps", "โลโก้และลิงก์บนเว็บไซต์เรา"] },
    region: { name: "เทศบาล", for: "เทศบาล ภูมิภาค และหน่วยงานการท่องเที่ยว", perks: ["โทรลล์ 20 ตัวทั่วเทศบาล", "เส้นทางโทรลล์ของคุณเอง", "สั่งล่วงหน้าด้วย Vipps สำหรับธุรกิจท้องถิ่น", "โลโก้และลิงก์บนเว็บไซต์เรา"] },
  },
  custom: "ต้องการโทรลล์มากกว่า 20 ตัว หลายเทศบาล หรือเส้นทางใหม่ทั้งเส้น? เราออกแบบเส้นทางโทรลล์เฉพาะร่วมกับคุณได้",
  customCta: "สอบถามเส้นทางเฉพาะ",
  customName: "เส้นทางเฉพาะ",
  cityKicker: "เทศบาลและการท่องเที่ยว",
  cityTitle: "เมืองและเทศบาลที่อยากได้นักท่องเที่ยวเพิ่ม — นี่คือคำเชิญสำหรับคุณ",
  cityBody: [
    "นักท่องเที่ยวจำนวนมากแค่ขับรถผ่านไป การล่าโทรลล์ทำให้พวกเขามีเหตุผลที่จะแวะ พักต่ออีกคืน และสำรวจมากกว่าแค่จุดถ่ายรูปชื่อดังเพียงจุดเดียว",
    "ด้วยเส้นทางโทรลล์ของคุณเอง คุณจะกระจายผู้มาเยือนไปยังหมู่บ้าน เส้นทางเดิน ร้านค้า และคาเฟ่ — และเปลี่ยนเรื่องเล่าท้องถิ่น ธรรมชาติ และธุรกิจให้กลายเป็นเกมที่ทั้งครอบครัวอยากเล่นให้จบ",
  ],
  cityPoints: ["การพักค้างคืนมากขึ้นและการเยือนที่นานขึ้น", "ลูกค้าเพิ่มขึ้นสำหรับธุรกิจท้องถิ่น แม้นอกฤดูกาล", "ครอบครัว กรุ๊ปทัวร์ นักเดินป่า และนักสกี", "กิจกรรมกลางแจ้งสมัยใหม่ที่อวดธรรมชาติและวัฒนธรรมของคุณ"],
  cityCta: "มาคุยเรื่องความร่วมมือกัน",
  stepsKicker: "ขั้นตอน",
  stepsTitle: "จากไอเดียสู่โทรลล์ในสี่ขั้นตอน",
  steps: [
    { h: "ติดต่อเรา", p: "เล่าให้เราฟังเกี่ยวกับสถานที่ของคุณและแพ็กเกจที่คุณสนใจ" },
    { h: "ส่งรายชื่อสถานที่", p: "ส่งรายการสถานที่พร้อมพิกัด และประเภทโทรลล์ที่ต้องการในแต่ละจุด" },
    { h: "เราสร้างและวางโทรลล์", p: "เราออกแบบโทรลล์ ปักหมุดบนแผนที่ และตั้งค่าข้อมูลร้านกับระบบสั่งล่วงหน้าด้วย Vipps" },
    { h: "ผู้มาเยือนพบคุณ", p: "โทรลล์ของคุณออนไลน์ในแอป ต่ออายุทุกปี — และเพิ่มโทรลล์ได้ทุกเมื่อ" },
  ],
  faqTitle: "คำถามจากภาคธุรกิจ",
  faq: [
    ["เราเลือกตำแหน่งที่โทรลล์ยืนได้เองไหม?", "ได้ คุณส่งตำแหน่งพร้อมพิกัดมาให้เรา — หน้าร้าน ในสวน หรือตามเส้นทางเดิน — แล้วเราจะวางโทรลล์ไว้ตรงนั้น"],
    ["เราเลือกหน้าตาของโทรลล์ได้ไหม?", "คุณเลือกประเภทโทรลล์สำหรับแต่ละจุดได้ เช่น โทรลล์คนทำขนมปังสำหรับร้านเบเกอรี่ หรือโทรลล์ซาวน่าข้างซาวน่า เราวาดในสไตล์สีน้ำของ Trollfossjakten"],
    ["การสั่งล่วงหน้าด้วย Vipps ทำงานอย่างไร?", "ผู้เล่นที่พบโทรลล์ของคุณสามารถสั่งล่วงหน้ากับคุณในแอปและจ่ายด้วย Vipps โดยคุณเป็นผู้กำหนดว่าจะให้สั่งอะไรได้บ้าง"],
    ["แพ็กเกจใช้ได้นานแค่ไหน?", "หนึ่งปีนับจากวันที่โทรลล์ของคุณออนไลน์ และต่ออายุได้ทุกปี ราคาเปิดตัวใช้กับผู้สนับสนุน 50 รายแรก"],
    ["ราคารวม VAT หรือยัง?", "ยังไม่รวม ราคาทั้งหมดเป็นราคาต่อปีและไม่รวม VAT (eks. mva)"],
  ],
  finalTitle: "พร้อมปักหมุดสถานที่ของคุณบนแผนที่แล้วหรือยัง?",
  finalBody: "ติดต่อเรา แล้วเราจะหาแพ็กเกจที่เหมาะกับคุณ — หรือสร้างเส้นทางโทรลล์เฉพาะสำหรับเทศบาลของคุณ",
  finalCta: "ติดต่อเรา",
};

export default th;
